import styled, { keyframes } from 'styled-components';

const breatheAnimation = keyframes`
 from { bottom : -200px }
 to {  bottom: 10px }
`;

const backgroundAnimation = keyframes`
 from { opacity : 0.1 }
 to {  opacity: 1 }
`;

export const StyledAnnotationModal = styled.div`
  z-index: 100;
  position: fixed;
  width: 500px;
  max-width: 100%;
  min-width: 300px;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0%);
  height: 400px;
  margin: 20px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 5px 0 rgb(0 0 0 / 30%);
  padding: 10px 20px;
  animation-name: ${breatheAnimation};
  animation-duration: 0.4s;
`;

export const StyledOverlay = styled.div`
  z-index: 50;
  background-color: rgb(0 0 0 / 30%);
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  animation-name: ${backgroundAnimation};
  animation-duration: 0.4s;
`;
